export default __webpack_public_path__ + "static/media/03_RoweOil-Commercial-EschweilerPhotography_M1A0173_1_flat_Shadows.ce8fab88.jpg";